import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { SimpleTableTypeComponent } from './simple-table-type.component';
import {
  AvatarModule,
  MatTooltipAddonsDirective,
} from '@lockton-apps/shared/ui/lui';
import { MaterialModule } from '@lockton-apps/material';

@NgModule({
  declarations: [SimpleTableTypeComponent],
  imports: [
    CommonModule,
    AvatarModule,
    MaterialModule,
    MatTooltipAddonsDirective,
    FormlyModule.forChild({
      types: [
        {
          name: 'simple-table',
          component: SimpleTableTypeComponent,
          wrappers: ['addons'],
        },
      ],
    }),
  ],
})
export class SimpleTableTypeModule {}
